import {
  axios, toCamelCase, toSnakeCase,
} from '@utils';

const BASE_URL = '/api/v1/legup/leads';

async function providerOptinPaidLeads(paymentMethodId) {
  const url = `${BASE_URL}/provider_optin_paid_leads`;
  const { data } = await axios.put(url, {
    payment_method_id: paymentMethodId,
  });
  return toCamelCase(data);
}

async function removeLead({ childId, centerId }) {
  const url = `${BASE_URL}/remove_lead`;
  const { data } = await axios.put(url, {
    center_id: centerId,
    child_id: childId,
  });
  return toCamelCase(data);
}

async function providerOptOut() {
  const url = `${BASE_URL}/provider_opt_out_paid_leads`;
  const { data } = await axios.put(url);
  return toCamelCase(data);
}

async function fetchNewLeadsCount() {
  const response = await axios.get(`${BASE_URL}/new_count`);
  return toCamelCase(response.data);
}

async function markSeen(params) {
  const response = await axios.put(`${BASE_URL}/mark_seen`, toSnakeCase(params));
  return toCamelCase(response);
}
export {
  providerOptinPaidLeads, removeLead, providerOptOut,
  fetchNewLeadsCount, markSeen,
};
